module.exports = "https://la-static.vkplay.ru/promo/3/img/promo-logo.593800cc.png";